// Generate code from clean architecture template

import { CenterEntity } from '../entities';
import { CenterPayloadForm } from '../ports/payloads';
import { CenterRepository } from '../ports/repositories';

export class CreateCenterUsecase {
  constructor(private readonly repo: CenterRepository) {}

  async run(payload: CenterPayloadForm): Promise<CenterEntity> {
    const data = await this.repo.createCenter(payload);
    return data;
  }
}
